export const EMPTY_CATEGORY = {
  name: "",
  words: ["", "", "", ""] as [string, string, string, string],
};

export const INITIAL_CATEGORIES = [
  { ...EMPTY_CATEGORY },
  { ...EMPTY_CATEGORY },
  { ...EMPTY_CATEGORY },
  { ...EMPTY_CATEGORY },
];
